import { Chip, Typography } from "@mui/material";
import React, { useContext } from "react";
import FormContext from "../../../context/form-context";
import { statusColor } from "../../../utils/utilities";
import useTransactionDetails from "./useTransactionDetails";


const TransactionDetails = () => {
    const {appState} = useContext(FormContext)
    const {agentDetails} = appState;
    const {status} = appState.formInfo;
    const {form, type} = appState.formType;
    const {mainValues} = appState.formState;
    
    useTransactionDetails();

    const getPropertyAddress = (value) => {
        const blk = value.blk || "" 
        const unit = value.unit || "" 
        const floor = value.floor || "" 
        const streetName = value.streetName || "" 
        const postal = value.postalCode || "" 
    
        return `${blk} ${unit} ${floor} ${streetName} ${postal}`;
    }
    
    return (
        <>
            {/* <div style={{ display: 'flex', justifyContent: 'flex-end' }}> */}
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                {/* <strong> Sales Person:</strong> {`${agentDetails?.full_name} (${agentDetails?.display_name})`} */}
                <strong> Sales Person:</strong> {`${agentDetails?.full_name}`}
            </Typography>
            {((form && type) || mainValues?.propertyAddress)
                &&
                <>
                    <Typography variant="h6" gutterBottom>
                        <strong> Property Address:</strong> {`${mainValues?.propertyAddress ? mainValues?.propertyAddress : getPropertyAddress(mainValues)}`}
                    </Typography>
                    <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                        <strong> Status:</strong> <Chip sx={{ m: 1, backgroundColor: statusColor(status) }} label={`${status}`} />
                    </Typography>
                </>

            }
        </>
    )
}

export default TransactionDetails;